"use client";

import { clsx } from "@trydig/ui";
import type { ComponentProps } from "react";
import { useState } from "react";
import { Close } from "~/components/icons/16/Close";
import { SearchIcon } from "~/components/icons/SearchIcon";
import styles from "./search-bar.module.css";

export type SearchBarProps = ComponentProps<"input"> & {
	onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
	isModalOpen?: boolean;
	clearValue?: () => void;
};

export const SearchBar = ({
	value: externalValue,
	placeholder,
	clearValue,
	isModalOpen,
	className,
	onSubmit,
	...props
}: SearchBarProps) => {
	const [searchValue, setSearchValue] = useState(externalValue);

	const value = externalValue ?? searchValue;

	const handleClear = (_e: React.MouseEvent<HTMLButtonElement>) => {
		clearValue?.();
	};

	return (
		<form
			className={clsx(styles["search-form"], isModalOpen && styles.active, className)}
			onSubmit={(e) => {
				e.preventDefault();
				onSubmit?.(e);
			}}
		>
			<input
				type="text"
				className={`${(value ?? searchValue) ? styles.active : ""}`}
				value={value ?? searchValue}
				onChange={(e) => {
					if (props?.onChange) props?.onChange(e);
					setSearchValue(e.target.value);
				}}
				id="search-input"
				{...props}
			/>
			<label htmlFor="search-input">{placeholder}</label>
			<button onClick={handleClear} type={"reset"}>
				{value ? <Close /> : <SearchIcon size="large" />}
			</button>
		</form>
	);
};
